
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationM as ObiLocationMElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-m.js';
 
 
 

 
 export const ObiLocationM = createComponent({
   react: React,
   tagName: 'obi-location-m',
   elementClass: ObiLocationMElement,
   events: {
     
   }
  });
 
 